import { useMemo } from 'react';

import { useSelector } from '#/reduxState/storeCore';

export function useWithdrawDisabledMessage(): string | false {
  const withdrawEnabled = useSelector(
    state => state.exchange.info.withdrawEnabled
  );

  const withdrawalDisabledMessage = useMemo((): false | string => {
    if (!withdrawEnabled) {
      return 'Withdrawals are temporarily disabled.';
    }
    return false;
  }, [withdrawEnabled]);

  return withdrawalDisabledMessage;
}
